import React from 'react';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';
import ErrorMessage from '../ErrorMessage';

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      value={props.value}
      decimalScale={2}
    />
  );
};

const NumberField = (props) => {
  const { errors, children } = props;
  const hasErrors = errors && errors.length > 0;
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: NumberFormatCustom,
      }}
      error={hasErrors}
      helperText={hasErrors ? <ErrorMessage errors={errors} /> : null}
    >
      {children}
    </TextField>
  );
};

export default NumberField;
